import { inject, Injectable } from '@angular/core';
import { FirestoreService } from '../firestore.service';
import { NotFoundException } from '../not-found-exception';

export type ProfileGoal = {
  id: string;
  updated_at: Date;
  created_at: Date;
  person_id: string;
  goal: string;
  goal_by_when: string;
}

@Injectable({
  providedIn: 'root',
})
export class ProfileGoalsService {
  private firestoreService = inject(FirestoreService);

  private collectionPath = 'ProfileGoals';

  async create(ProfileGoal: ProfileGoal): Promise<string> {
    const newID = this.firestoreService.generateId([this.collectionPath]);
    ProfileGoal.id = newID;
    await this.firestoreService.set([this.collectionPath, newID], ProfileGoal);
    return newID;
  }

  async getOne(id: string): Promise<ProfileGoal> {
    return await this.firestoreService.docOnce<ProfileGoal>([this.collectionPath, id]);
  }

  async getByPerson(personId: string): Promise<ProfileGoal[]> {
    return await this.firestoreService.colOnce<ProfileGoal>({
      pathSegments: [this.collectionPath],
      where: ['person_id', '==', personId],
    });
  }

  async getMostCurrentByPerson(personId: string): Promise<ProfileGoal> {
    const profiles = await this.firestoreService.colOnce<ProfileGoal>({
      pathSegments: [this.collectionPath],
      where: ['person_id', '==', personId],
      orderBy: ['created_at', 'desc'],
      limit: 1,
    });
    if (profiles.length > 0) {
      return profiles[0];
    } else {
      throw new NotFoundException(`ProfileGoal not found for ${personId}`);
    }
  }

  async update(id: string, profileGoal: ProfileGoal): Promise<void> {
    return await this.firestoreService.update([this.collectionPath, id], profileGoal);
  }
}
